import { VehicleDamageDto } from 'dtos'
import { useLoadingState } from 'hooks'
import { enqueueSnackbar } from 'notistack'
import { Button, Card, CardContent, Divider, Grid, TextField } from '@mui/material'
import { ArrowLeft, ArrowRight } from '@mui/icons-material'
import { GreenText } from 'components'
import AddDamageStepper from './AddDamageStepper'
import { useState } from 'react'

interface Step2ReportDamageProps {
  onBack: () => void
  onNext: () => void
  damageDescription: string
  setDamageDescription: (value: string) => void
  loading: boolean
  damage: VehicleDamageDto
  vehicleGuid?: string
}

export default function Step2ReportDamage({ onBack, onNext, damageDescription, setDamageDescription }: Step2ReportDamageProps) {
  const [loadingState] = useLoadingState({})
  const [error, setError] = useState(false)

  const handleNext = () => {
    if (!damageDescription.trim()) {
      setError(true)
      enqueueSnackbar('Damage description is required.', { variant: 'error' })
      return
    }

    onNext()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDamageDescription(e.target.value)
    if (e.target.value.trim()) setError(false)
  }

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={12}>
            <AddDamageStepper activeStep={1} />
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12} marginTop={2}>
            <TextField
              fullWidth
              label='Damage Description'
              multiline
              rows={6}
              name='damageDescription'
              type='text'
              value={damageDescription}
              onChange={handleChange}
              error={error}
              helperText={error ? 'Damage description is required' : ''}
              inputProps={{ maxLength: 1000 }}
            />
          </Grid>

          <Grid item xs={12} marginTop={2}>
            <Button
              color='primary'
              endIcon={<ArrowRight />}
              fullWidth
              onClick={handleNext}
              type='button'
              variant='contained'
              disabled={!damageDescription.trim()}
            >
              NEXT
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Button color='primary' startIcon={<ArrowLeft />} fullWidth onClick={onBack} variant='outlined'>
              PREVIOUS
            </Button>
          </Grid>

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**Vehicle Damage Steps:**

Displays the current step of the vehicle in the Damage
process.

**Damage Description:**

Is a required free-type text field that allows users to input
details about the vehicles reported damage

Max character count: 1000 characters.

**Next Button:**

Clicking the Next Button will take the user to the next step in
the Damage process.

- Save changes made during the current step.

- Advance the user to the next step in the Damage process.

**PREVIOUS Button:**

Clicking this button will:

- Discard any changes made in the current step.

- Return the user to the previous step in the Damage
process.
              `}
            </GreenText>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
